module.exports = __webpack_public_path__ + "static/media/dr-bourriez-pp.641b1a88.png";